export const valoresExibidosOffCanvasKitProdutos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorTags: '',
  separadorObservacoes: '',

  //Específicos
  statusKit: 'Status',
  componenteAF: 'Componente AF',
  nomeKit: 'Nome do Kit',
  descricao: 'Descrição',
  produtos: 'Produtos',
};

export const headersKitsProdutos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 7, key: 'statusKit' },
  { text: 'Componente', width: 10, key: 'componenteAF' },
  { text: 'Kit', width: 20, key: 'nomeKit' },
  { text: 'Produtos', width: 65, key: 'produtos' },
];

export const fieldObjectKits = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
